import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const col1 = categories.slice(0, 5);
  const col2 = categories.slice(5, 10);
  const col3 = categories.slice(10);

  return (
    <footer className="bg-secondary-50 border-t border-background-200/60">
      <div className="w-full max-w-[1400px] mx-auto px-6 md:px-10 py-14 md:py-20">
        <div className="bg-background-50 rounded-2xl px-8 md:px-12 py-10 md:py-14 relative overflow-hidden">
          <div className="absolute -top-6 -right-6 w-24 h-24 bg-accent-200/30 rounded-full -rotate-12"></div>
          <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-secondary-200/30 rounded-full rotate-12"></div>

          <div className="relative grid grid-cols-1 md:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="font-heading text-xl font-bold text-foreground-900">
                superbuyspread<span className="text-accent-500">.pics</span>
              </Link>
              <p className="mt-4 text-sm text-foreground-500 leading-relaxed max-w-xs">
                Your trusted resource for Superbuy Sheet product discovery. Explore organized category guides, tutorials, and shopping tips to find products faster and smarter.
              </p>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">Categories</h4>
              <ul className="space-y-2.5">
                {col1.map((cat) => (
                  <li key={cat.name}>
                    <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer">
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">More Categories</h4>
              <ul className="space-y-2.5">
                {col2.map((cat) => (
                  <li key={cat.name}>
                    <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer">
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">Resources</h4>
              <ul className="space-y-2.5">
                {col3.map((cat) => (
                  <li key={cat.name}>
                    <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer">
                      {cat.name}
                    </a>
                  </li>
                ))}
                <li className="pt-2 border-t border-background-200/60 mt-2">
                  <Link to="/article/superbuy-sheet-complete-guide" className="text-sm text-foreground-600 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer">
                    Complete Guide
                  </Link>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-accent-600 hover:text-accent-700 font-medium transition-colors whitespace-nowrap cursor-pointer">
                    superbuy sheet →
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <span>&copy; 2026 superbuyspread.pics</span>
            <span className="hidden sm:inline text-foreground-300">|</span>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="hover:text-foreground-600 transition-colors cursor-pointer">Privacy</a>
            <span className="hidden sm:inline text-foreground-300">|</span>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="hover:text-foreground-600 transition-colors cursor-pointer">Terms</a>
          </div>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-100 text-foreground-500 hover:bg-accent-100 hover:text-accent-600 transition-colors cursor-pointer">
              <i className="ri-twitter-x-line text-sm"></i>
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-100 text-foreground-500 hover:bg-accent-100 hover:text-accent-600 transition-colors cursor-pointer">
              <i className="ri-pinterest-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}